import { render, staticRenderFns } from "./SuppliersInfoModal.vue?vue&type=template&id=99fd136e&"
import script from "./SuppliersInfoModal.vue?vue&type=script&lang=js&"
export * from "./SuppliersInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports